<ng-container
  *ngLet="{
    filterable: defaultedFilterable | async,
    filterEmpty: filterEmpty | async,
    filterPositionBottom: defaultedFilterPositionBottom | async,
    disabled: defaultedDisabled | async,
    exact: defaultedExact | async,
    options: defaultedOptions | async,
    optionsLoadable: uiOptionsLoadable | async,
    nodes: nodesLimited | async,
    notShownCount: notShownCount | async,
    filter: filter | async,
    selectedNodes: selectedNodes | async
  } as vm"
>
  <option-filter
    class="container sneaky-scroll"
    *ngIf="vm.filterable"
    [autoFocus]="true"
    [disabled]="vm.disabled"
    [inputPositionBottom]="vm.filterPositionBottom"
    [filter]="vm.filter"
    [filterEmpty]="vm.filterEmpty"
    (filterChange)="filter.next($event); filterChange.emit($event)"
  >
    <ng-container
      *ngTemplateOutlet="optionsTemplate; context: { $implicit: vm.nodes }"
    ></ng-container>
  </option-filter>
  <div class="container sneaky-scroll" *ngIf="!vm.filterable">
    <div class="rv-scrollable">
      <ng-container
        *ngTemplateOutlet="optionsTemplate; context: { $implicit: vm.nodes }"
      ></ng-container>
    </div>
  </div>
  <ng-template #optionsTemplate let-nodes>
    <div
      class="rv-flex show-selected-row"
      (click)="showSelected = !showSelected"
      *ngIf="selectedEnabled"
    >
      <div>Selected</div>
      <div class="rv-flex show-selected-arrow">
        <span>
          {{ vm.selectedNodes?.length || '0' }}
        </span>
        <riv-icon
          [name]="showSelected ? 'ChevronUp' : 'ChevronDown'"
        ></riv-icon>
      </div>
    </div>
    <loadable class="fill" [data]="vm.optionsLoadable" [size]="40">
      <ng-container *ngIf="selectedEnabled">
        <div class="selected-nodes">
          <ng-container *ngIf="showSelected">
            <ng-container
              *ngTemplateOutlet="
                nodesTemplate;
                context: { $implicit: vm.selectedNodes }
              "
            ></ng-container>
          </ng-container>
        </div>
      </ng-container>
      <div>
        <ng-container
          *ngTemplateOutlet="nodesTemplate; context: { $implicit: nodes }"
        ></ng-container>
        <div class="more" *ngIf="vm.notShownCount > 0">
          {{ vm.notShownCount }} more... (Search to narrow results)
        </div>
      </div>
    </loadable>
  </ng-template>
  <ng-template #nodesTemplate let-nodes>
    <ng-container *ngFor="let node of nodes; let i = index; trackBy: trackBy">
      <multi-select-node
        [autoFocus]="i == 0 && !vm.filterable"
        [disabled]="vm.disabled"
        [displayId]="displayId"
        [selected]="!!node.selected"
        (selectedChange)="select.next([node.id, $event])"
        [identifier]="node.id"
        [subtitle]="node.subtitle"
        [subtitleHighlightIndices]="node.subtitleHighlightIndices"
        [title]="node.title"
        [titleHighlightIndices]="node.titleHighlightIndices"
        [count]="node.count"
      ></multi-select-node>
    </ng-container>
  </ng-template>
</ng-container>
